function vkey(vendor, name) {
  const id = vendor?.id || vendor?.restaurant_id || "anon";
  return `v1s:${id}:${name}`;
}

export function loadLocal(vendor, name, fallback) {
  try {
    const r = localStorage.getItem(vkey(vendor, name));
    return r ? JSON.parse(r) : fallback;
  } catch {
    return fallback;
  }
}

export function saveLocal(vendor, name, val) {
  localStorage.setItem(vkey(vendor, name), JSON.stringify(val));
}

export function uid() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
}
